import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Typography,
  message,
  Spin,
  Select,
} from "antd";
import axios from "axios";
import { baseUrl, platformApi } from "../../../../../api";
import { withRouter } from "react-router-dom";
import moment from "moment";

const { Title } = Typography;
const { Option } = Select;

const PDFGenerator = ({
  open,
  close,
  pdfData,
  sms,
  sentStatus,
  sentWhatsApp,
  editable,
  smsTime,
  setSmsTime,
  setFlag,
  flag,
  whatsapp,
  whatsappTime,
  setWhatsAppTime,
  wFlag,
  setWFlag,
  whatsappData,
  fromCall,
}) => {
  const [loading, setLoading] = useState({
    print: false,
    sms: false,
    whatsApp: false,
    assign: false,
  });

  // New states for branch and executive assignment
  const [branches, setBranches] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedExecutive, setSelectedExecutive] = useState(null);

  useEffect(() => {
    // Fetch branches when component mounts and fromCall is true
    if (fromCall && open) {
      fetchBranches();
    }
  }, [fromCall, open]);

  useEffect(() => {
    if (pdfData?.assignedBranch) {
      setSelectedBranch({
        id: pdfData.assignedBranch.id,
        name: pdfData.assignedBranch.name,
      });

      // Ensure prefilled branch appears in options
      setBranches((prev) => {
        const exists = prev?.some((b) => b.id === pdfData.assignedBranch.id);
        if (exists) return prev;
        return [
          ...prev,
          { id: pdfData.assignedBranch.id, name: pdfData.assignedBranch.name },
        ];
      });
    }

    if (pdfData?.assignedExecutive) {
      console.log(
        "2L",
        pdfData.assignedExecutive.id,
        pdfData.assignedExecutive.profile.employeeName
      );

      setSelectedExecutive({
        id: pdfData.assignedExecutive.id,
        name: pdfData.assignedExecutive.profile.employeeName,
      });

      // Ensure prefilled executive appears in options
      setEmployees((prev) => {
        const exists = prev?.some((e) => e.id === pdfData.assignedExecutive.id);
        if (exists) return prev;
        return [
          ...prev,
          {
            id: pdfData.assignedExecutive.id,
            name: pdfData.assignedExecutive.profile.employeeName,
            employeeId: pdfData.assignedExecutive.profile.employeeId,
          },
        ];
      });
    }
  }, [pdfData]);

  // Fetch all branches
  const fetchBranches = () => {
    platformApi
      .get("/api/company/branches")
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setBranches(response.data);
            // Set first branch as default and fetch its employees
            if (response.data.length > 0) {
              const firstBranch = response.data[0];
              if(!pdfData.assignedBranch){
                setSelectedBranch({
                  id: firstBranch.id,
                  name: firstBranch.name,
                });
              }
              fetchEmployeesBasedOnBranch(firstBranch.id);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
        message.error("Unable to fetch branches");
      });
  };

  // Fetch employees based on selected branch
  const fetchEmployeesBasedOnBranch = (branchId) => {
    platformApi
      .post("/api/user/get", {
        size: 1000,
        page: 1,
      })
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let filteredEmployees = [];
            response.data.users.forEach((element) => {
              let sale = false;
              element.profile.department.departmentType.forEach((data) => {
                if (data === "Sales") {
                  sale = true;
                  return;
                }
              });

              // Sale department check
              if (sale) {
                // Branch check
                let belongsToBranch = false;
                element.profile.branch.forEach((branch) => {
                  if (branch.id === branchId) {
                    belongsToBranch = true;
                    return;
                  }
                });

                if (belongsToBranch && element.status === true) {
                  filteredEmployees.push({
                    id: element.id,
                    name: element.profile.employeeName,
                    employeeId: element.profile.employeeId,
                  });
                }
              }
            });
            setEmployees(filteredEmployees);
            if(!pdfData.assignedExecutive){
              setSelectedExecutive(null);
            }
          }
        }
      })
      .catch((error) => {
        message.error("Unable to fetch employees", 1);
        console.error("Error fetching employees: ", error);
      });
  };

  const handleBranchChange = (value, option) => {
    const branch = {
      id: value,
      name: option.children,
    };
    setSelectedBranch(branch);
    fetchEmployeesBasedOnBranch(value);
  };

  const handleExecutiveChange = (value, option) => {
    const executive = {
      id: value,
      name: option.children,
    };
    setSelectedExecutive(executive);
  };

  const handleAssignExecutive = () => {
    if (!selectedBranch || !selectedExecutive) {
      message.error("Please select both branch and sales executive");
      return;
    }

    setLoading({ ...loading, assign: true });

    const payload = {
      branch: selectedBranch,
      executive: selectedExecutive,
      quotationId: pdfData.id,
    };

    platformApi
      .post("/api/quotation/assignExecutive", payload)
      .then((result) => {
        setLoading({ ...loading, assign: false });
        const { data } = result;
        if (data.code === 200) {
          message.success("Executive assigned successfully");
          setSelectedExecutive(null);
        } else {
          message.error("Unable to assign executive");
        }
        close();
      })
      .catch((error) => {
        console.error("Error assigning executive: ", error);
        setLoading({ ...loading, assign: false });
        message.error("Unable to assign executive");
      });
  };

  const sendSMS = (data, type) => {
    if (type === "SMS") {
      data.type = type;
      setLoading({ ...loading, sms: true });
      platformApi
        .post("api/sendSms/quotation", data)
        .then((result) => {
          setLoading({ ...loading, sms: false });
          const { data } = result;
          if (data.code === 200) {
            message.success("Message sent successfully");
            setFlag(true);
            setSmsTime(new Date());
          } else if (data.code === 401) {
            message.error(data.message);
          } else {
            message.error("Unable to send SMS");
          }
        })
        .catch((error) => {
          console.error("Error in PDF Generator : ", error);
          setLoading({ ...loading, sms: false });
          message.error("Unable to send SMS");
        });
    } else if (type === "WhatsApp") {
      data.type = type;
      setLoading({ ...loading, whatsApp: true });
      platformApi
        .post("api/sendSms/quotation", data)
        .then((result) => {
          setLoading({ ...loading, whatsApp: false });
          const { data } = result;
          if (data.code === 200) {
            message.success("WhatsApp Message sent successfully");
            setWFlag(true);
            setWhatsAppTime(new Date());
            // if (data.response && data.response.data && data.response.data.debugMessage) {
            //   console.log(
            //     "[WhatsApp][Quotation][Final Message]",
            //     data.response.data.debugMessage
            //   );
            // }
          } else if (data.code === 400) {
            message.error(data.message);
          } else if (data.code === 401) {
            message.error(data.message);
          } else {
            message.error("Unable to send WhatsApp SMS");
          }
        })
        .catch((error) => {
          console.error("Error in PDF Generator : ", error);
          setLoading({ ...loading, whatsApp: false });
          message.error("Unable to send SMS");
        });
    }
  };

  useEffect(() => {
    console.log(whatsapp, whatsappTime, setWhatsAppTime, wFlag, setWFlag);
  }, []);

  const triggerSMS = () => sendSMS({ ...pdfData }, "SMS");

  const triggerWhatsAppSMS = () => {
    if (!whatsappData?.customerNo) {
      message.error("Customer Number Invalid");
      return;
    }

    setLoading({ ...loading, whatsApp: true });
    const payload = { ...pdfData, type: "WhatsAppPreview" };

    platformApi
      .post("api/sendSms/quotation", payload)
      .then((result) => {
        setLoading({ ...loading, whatsApp: false });
        const { data } = result;
        console.log("[WhatsApp][Quotation][Preview Response]", data);
        if (data.code === 200) {
          message.success("WhatsApp Message sent successfully");
          setWFlag(true);
          setWhatsAppTime(new Date());
        } else {
          message.error("Unable to send WhatsApp message");
        }
      })
      .catch((error) => {
        console.error("Error preparing WhatsApp preview: ", error);
        setLoading({ ...loading, whatsApp: false });
        message.error("Unable to prepare WhatsApp message");
      });
  };

  const clearFields = () => {
    setLoading({ print: false, sms: false, assign: false });
    setFlag(false);
    // Reset assignment fields when closing
    setSelectedBranch(null);
    setSelectedExecutive(null);
    setEmployees([]);
  };

  return (
    <Modal
      title={<Title level={4}>PDF Generation</Title>}
      visible={open}
      width={
        typeof window !== "undefined" && window.innerWidth < 768
          ? "95vw"
          : "35vw" 
      }
      onCancel={!loading.sms && !loading.print && !loading.generation && close}
      footer={[
        ...(fromCall && !(pdfData?.assignedBranch && pdfData?.assignedExecutive)
          ? [
              <Button
                key="assign"
                type="primary"
                loading={loading.assign}
                onClick={handleAssignExecutive}
                disabled={!selectedBranch || !selectedExecutive}
              >
                Assign
              </Button>,
            ]
          : []),
        <Button
          key={"button"}
          onClick={() => {
            clearFields();
            close();
          }}
          disabled={
            loading.sms || loading.print || loading.generation || loading.assign
          }
        >
          Close
        </Button>,
      ]}
    >
      {pdfData.id && (
        <div>
          {/* First Row: Buttons */}
          <Row gutter={[16, 16]} style={{ marginBottom: fromCall ? 20 : 0 }}>
        <Col xs={24} sm={12}>
  <Button
    loading={loading.print}
    type="dashed"
    icon="file-pdf"
     onClick={() => {
      setLoading({ ...loading, print: true });
      window.open(`${baseUrl}api/quotation/generatePdf/${pdfData.id}`, '_blank');
      setTimeout(() => setLoading({ ...loading, print: false }), 1000);
    }}
  >
    Download Quotation
  </Button>
</Col>
            <Col xs={24} sm={12}>
              <Button
                icon="message"
                type="dashed"
                loading={loading.whatsApp}
                onClick={triggerWhatsAppSMS}
                style={{ width: "100%" }}
              >
                Send via WhatsApp
              </Button>
            </Col>
          </Row>

          {/* Assignment Section */}
          {(fromCall ||
            pdfData?.assignedBranch ||
            pdfData?.assignedExecutive) && (
            <div>
              <h3 style={{ marginBottom: 16 }}>Assign Executive</h3>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <div style={{ marginBottom: 8, fontWeight: 500 }}>
                    Branch:
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select Branch"
                    value={selectedBranch?.id}
                    onChange={handleBranchChange}
                    disabled={!!pdfData?.assignedBranch}
                  >
                    {branches.map((branch) => (
                      <Option key={branch.id} value={branch.id}>
                        {branch.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ marginBottom: 8, fontWeight: 500 }}>
                    Sales Executive:
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select Sales Executive"
                    value={selectedExecutive?.id}
                    onChange={handleExecutiveChange}
                    disabled={!selectedBranch || !!pdfData?.assignedExecutive}
                    // size="large"
                  >
                    {employees.map((employee) => (
                      <Option key={employee.id} value={employee.id}>
                        {employee.name} ({employee.employeeId})
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

export default withRouter(PDFGenerator);
